import {nextArrow, prevArrow} from '../components/slick-arrow';

export const popularCategorySliderOptions = {
    slidesToShow: 7,
    dots: false,
    arrows: true,
    infinite: false,
    waitForAnimate: false,
    nextArrow: nextArrow(),
    prevArrow: prevArrow(),
    rows: 0,
    responsive: [
        {
            breakpoint: 1920,
            settings: {
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 1280,
            settings: 'unslick',
        },
    ]
}

export const mainSliderOptions = {
    autoplay: true,
    autoplaySpeed: 10000,
    dots: true,
    arrows: false,
    infinite: true,
    rows: 0,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                fade: true,
                speed: 100,
            }
        }
    ]
}

export const productsSliderOptions = {
    slidesToShow: 6,
    dots: false,
    arrows: true,
    infinite: false,
    waitForAnimate: false,
    nextArrow: nextArrow(),
    prevArrow: prevArrow(),
    rows: 0,
    responsive: [
        {
            breakpoint: 1920,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 1280,
            settings: 'unslick'
        },
    ]
}

export const accessoryCategoriesSliderOptions = {
    arrows: true,
    dots: false,
    nextArrow: nextArrow(),
    prevArrow: prevArrow(),
    variableWidth: true,
    infinite: false,
    swipe: false,
    rows: 0,
    responsive: [
        {
            breakpoint: 768,
            settings: 'unslick'
        }
    ]
}